import { Component, Inject } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PackageConsumptionHistoryResponseDTO } from 'src/app/models/dtos/package-consumption-history-response-DTO';

@Component({
  selector: 'app-consumption-history-dialog',
  templateUrl: './consumption-history-dialog.component.html',
  styleUrls: ['./consumption-history-dialog.component.scss']
})
export class ConsumptionHistoryDialogComponent {
  consumptionHistory: PackageConsumptionHistoryResponseDTO[] = [];
  packageName: string = '';
  boatName: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.consumptionHistory = this.config.data?.consumptionHistory || [];
    this.packageName = this.config.data?.packageName || '';
    this.boatName = this.config.data?.boatName || '';
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('pt-BR');
  }

  formatDateTime(date: Date): string {
    return new Date(date).toLocaleString('pt-BR');
  }

  close(): void {
    this.ref.close();
  }
}